import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuLabel, 
  DropdownMenuSeparator, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { Settings, LogOut, Key } from 'lucide-react';
import { StaffBadge } from '@/components/common/StaffBadge';
import { useUser } from '@/lib/contexts/UserContext';

const UserProfile: React.FC = () => {
  const { user, needsOnboarding, setNeedsOnboarding } = useUser();
  
  // Check if name is null, "null", or empty and trigger onboarding if needed
  useEffect(() => {
    if (user && (!user.name || user.name === 'null' || user.name.trim() === '')) {
      setNeedsOnboarding(true);
    }
  }, [user, setNeedsOnboarding]);

  const initials = user?.name && user.name !== 'null' && typeof user.name === 'string' ? user.name.split(' ').map(n => n[0]).join('') : '?';

  return (
    <div className="p-4 border-t">
      <DropdownMenu>
        <DropdownMenuTrigger className="w-full" asChild>
          <button className="flex items-center gap-3 w-full hover:bg-accent/10 p-2 rounded-md transition-colors">
            <div className="relative">
              <div className="h-8 w-8 rounded-full bg-accent/20 flex items-center justify-center text-accent font-medium">
                {initials}
              </div>
              {/* Online status indicator */}
              <span className="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full bg-accent-teal border-2 border-sidebar"></span>
            </div>
            <div className="flex-1 text-left">
              <p className="text-sm font-medium">
                {user?.name && user.name !== 'null' ? user.name : 'Complete your profile'}
              </p>
              <div className="flex items-center gap-2">
                <p className="text-xs text-muted-foreground">{user?.role}</p>
                <StaffBadge />
              </div>
              <p className="text-xs text-muted-foreground">{user?.email}</p>
            </div>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link to="/settings/profile">
              <Settings className="mr-2 h-4 w-4" />
              <span>Settings</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/settings/api-keys">
              <Key className="mr-2 h-4 w-4" />
              <span>API Keys</span>
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link to="/api/auth/logout">
              <LogOut className="mr-2 h-4 w-4" />
              <span>Log out</span>
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default UserProfile;
